var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.prefixCls},[_vm._l((_vm.data),function(item){return _c('v-checkbox',{key:item[_vm.keyField],attrs:{"true-value":item[_vm.keyField],"disabled":item.disabled},on:{"change":_vm.itemChange,"click":_vm.itemClick}},[_vm._v(_vm._s(item[_vm.label]))])}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7151da9c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./vb/components/checkbox/checkbox-group.vue
// module id = null
// module chunks = 